<div
    class="avi-area-graph"
    [ngClass]="{ 'avi-area-graph__awaiting-data': isLoading }"
    #chart
>
    <!--  Buttons  -->
    <div
        class="avi-area-graph__button-wrapper"
        *ngIf="!isLoading && showButtons && dataset.length > 0"
    >
        <div class="btn-group btn-sm avi-area-graph__button-group">
            <div
                [ngClass]="{ 'avi-area-graph__button-disabled': !anomaliesCount }"
                aviTitle="{{ l10nKeys.anomaliesLabel | vtranslate }}"
                class="checkbox btn avi-area-graph__button sel-overlay-anomaly"
            >
                <input
                    [(ngModel)]="showAnomaly"
                    [disabled]="!anomaliesCount"
                    id="anomaly"
                    type="checkbox"
                />
                <label for="anomaly">
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="bolt"
                    ></cds-icon>
                    <span class="avi-area-graph__button-value">{{ anomaliesCount }}</span>
                </label>
            </div>
            <div
                [ngClass]="{ 'avi-area-graph__button-disabled': !alertsCount }"
                aviTitle="{{ globalL10nKeys.alertsLabel | vtranslate }}"
                class="checkbox btn avi-area-graph__button sel-overlay-alerts"
            >
                <input
                    [(ngModel)]="showAlerts"
                    [disabled]="!alertsCount"
                    id="alerts"
                    type="checkbox"
                />
                <label for="alerts">
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="bell"
                    ></cds-icon>
                    <span class="avi-area-graph__button-value">{{ alertsCount }}</span>
                </label>
            </div>
            <div
                [ngClass]="{ 'avi-area-graph__button-disabled': !configEventsCount }"
                aviTitle="{{ l10nKeys.configEventsLabel | vtranslate }}"
                class="checkbox btn avi-area-graph__button sel-overlay-config"
            >
                <input
                    [(ngModel)]="showConfigEvents"
                    [disabled]="!configEventsCount"
                    id="config-events"
                    type="checkbox"
                />
                <label for="config-events">
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="cog"
                    ></cds-icon>
                    <span class="avi-area-graph__button-value">{{ configEventsCount }}</span>
                </label>
            </div>
            <div
                aviTitle="{{ l10nKeys.systemEventsLabel | vtranslate }}"
                class="checkbox btn avi-area-graph__button sel-overlay-system"
                [ngClass]="{ 'avi-area-graph__button-disabled': !systemEventsCount }"
            >
                <input
                    [(ngModel)]="showSystemEvents"
                    [disabled]="!systemEventsCount"
                    id="system-events"
                    type="checkbox"
                />
                <label for="system-events">
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="power"
                    ></cds-icon>
                    <span class="avi-area-graph__button-value">{{ systemEventsCount }}</span>
                </label>
            </div>
        </div>

        <div class="btn-group btn-sm avi-area-graph__button-group">
            <span aviTitle="{{ l10nKeys.zoomInLabel | vtranslate }}">
                <button
                    (click)="handleZoomIn()"
                    class="btn avi-area-graph__button avi-area-graph__button--zoom-in"
                >
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="zoom-in"
                    ></cds-icon>
                </button>
            </span>

            <span aviTitle="{{ l10nKeys.zoomOutLabel | vtranslate }}">
                <button
                    (click)="handleZoomOut()"
                    [disabled]="isZoomOutDisabled"
                    class="btn avi-area-graph__button avi-area-graph__button--zoom-out"
                >
                    <cds-icon
                        class="avi-area-graph__button-icon"
                        shape="zoom-out"
                    ></cds-icon>
                </button>
            </span>
        </div>
    </div>

    <!--  Actual Graph  -->
    <div
        [hidden]="isLoading || dataset.length === 0"
        [id]="graphId"
        class="avi-area-graph__viewport"
    >
        <ng-container *ngIf="!isLoading && showButtons">
            <ng-container *ngIf="showAnomaly">
                <cds-icon
                    [style.left.px]="event.left"
                    [style.top.px]="event.top"
                    [ngClass]="{
                        'avi-area-graph__metric-icon-clicked': event.isActive,
                        'avi-area-graph__metric-icon--deactivated': currentActiveGridInfo && !event.isActive,
                    }"
                    *ngFor="let event of anomalies; trackBy: trackByIndex"
                    class="avi-area-graph__metric-icon avi-area-graph__metric-icon--bolt"
                    shape="bolt"
                    solid="true"
                    size="14"
                    (click)="onGraphIcon(event, 'anomalies')"
                ></cds-icon>
            </ng-container>

            <ng-container *ngIf="showAlerts">
                <cds-icon
                    [style.left.px]="event.left"
                    [style.top.px]="event.top"
                    [ngClass]="{
                        'avi-area-graph__metric-icon-clicked': event.isActive,
                        'avi-area-graph__metric-icon--deactivated': currentActiveGridInfo && !event.isActive,
                    }"
                    *ngFor="let event of alerts; trackBy: trackByIndex"
                    class="avi-area-graph__metric-icon avi-area-graph__metric-icon--bell"
                    shape="bell"
                    solid="true"
                    size="14"
                    (click)="onGraphIcon(event, 'alerts')"
                ></cds-icon>
            </ng-container>

            <ng-container *ngIf="showConfigEvents">
                <cds-icon
                    [style.left.px]="event.left"
                    [style.top.px]="event.top"
                    [ngClass]="{
                        'avi-area-graph__metric-icon-clicked': event.isActive,
                        'avi-area-graph__metric-icon--deactivated': currentActiveGridInfo && !event.isActive,
                    }"
                    *ngFor="let event of configEvents; trackBy: trackByIndex"
                    class="avi-area-graph__metric-icon avi-area-graph__metric-icon--cog"
                    shape="cog"
                    solid="true"
                    size="14"
                    (click)="onGraphIcon(event, 'configEvents')"
                ></cds-icon>
            </ng-container>

            <ng-container *ngIf="showSystemEvents">
                <cds-icon
                    [style.left.px]="event.left"
                    [style.top.px]="event.top"
                    [ngClass]="{
                        'avi-area-graph__metric-icon-clicked': event.isActive,
                        'avi-area-graph__metric-icon--deactivated': currentActiveGridInfo && !event.isActive,
                    }"
                    *ngFor="let event of systemEvents; trackBy: trackByIndex"
                    class="avi-area-graph__metric-icon avi-area-graph__metric-icon--power"
                    shape="power"
                    solid="true"
                    size="14"
                    (click)="onGraphIcon(event, 'systemEvents')"
                ></cds-icon>
            </ng-container>
        </ng-container>
    </div>

    <div
        *ngIf="!isLoading && dataset.length === 0"
        class="avi-area-graph__no-data"
    >
        {{ l10nKeys.emptyDataLabel | vtranslate }}
    </div>

    <!--  Spinner  -->
    <clr-spinner
        *ngIf="isLoading"
        clrInline
        [clrMedium]="true"
    ></clr-spinner>

    <!--  Legend  -->
    <div
        *ngIf="!isLoading && showLegends && labelList.length > 0"
        class="avi-area-graph__legend"
    >
        <h6 class="avi-area-graph__legend-label">
            {{ l10nKeys.showMetricsLabel | vtranslate }}
        </h6>

        <avi-legend
            [labelData]="labelData"
            *ngFor="let labelData of labelList; trackBy: trackByLabel"
            class="avi-area-graph__legend-label"
            (toggleLegends)="toggleLegends($event)"
        ></avi-legend>
    </div>

    <!--  Hover Tooltip Placeholder  -->
    <avi-bar-graph-tooltip
        #aviAreaGraphTooltipContainerElementRef
        class="avi-area-graph__tooltip"
        [left]="tooltipLeftPositionPx"
        [containerWidth]="graphWidth"
        [width]="tooltipWidth"
    >
        <ng-template #aviAreaGraphTooltipRef></ng-template>
    </avi-bar-graph-tooltip>
</div>
